// extracted by mini-css-extract-plugin
export default {"likeAction":"_LikeHeart_likeAction__V-2Fc"};